var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Overlay } from '@r1-frontend/ui-react/components/overlay';
import { Close } from '@r1-frontend/ui-react/components/svg/main';
import * as ST from './styled';
var DefaultPopup = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.isShowClose, isShowClose = _b === void 0 ? true : _b, isOpen = _a.isOpen, children = _a.children, fullWidth = _a.fullWidth, fullHeight = _a.fullHeight, className = _a.className, customStyles = _a.customStyles, onClose = _a.onClose, align = _a.align, justify = _a.justify, $zIndex = _a.$zIndex, rest = __rest(_a, ["width", "height", "isShowClose", "isOpen", "children", "fullWidth", "fullHeight", "className", "customStyles", "onClose", "align", "justify", "$zIndex"]);
    return (<Overlay $zIndex={$zIndex} align={align} justify={justify} isOpen={isOpen} fullWidth={fullWidth} fullHeight={fullHeight} onClose={onClose}>
            <ST.Popup width={width} height={height} fullWidth={fullWidth} className={className} customStyles={customStyles === null || customStyles === void 0 ? void 0 : customStyles.popup} {...rest}>
                {isShowClose &&
            <ST.ClosePopup bType={'secondary'} size={'small'} rounded Icon={<Close />} onClick={onClose} customStyles={customStyles === null || customStyles === void 0 ? void 0 : customStyles.closePopup}/>}
                {children}
            </ST.Popup>
        </Overlay>);
};
export default DefaultPopup;
